import { useMemo } from 'react';
import { useRequest } from 'ahooks';
import {
  fetchAdPlacements,
  IFetchAdPlacementsParams,
  IAdPlacementItem,
  TAdPlacementType,
} from './service';

export interface IUseAdPlacementResult {
  data: IAdPlacementItem[];
  marquees: IAdPlacementItem[];
  newicons: IAdPlacementItem[];
  loading: boolean;
  error?: any;
}

export const useAdPlacement = (
  baseUrl: string,
  type?: TAdPlacementType,
): IUseAdPlacementResult => {
  const requestParams = useMemo<IFetchAdPlacementsParams>(
    () => ({ baseUrl, type }),
    [baseUrl, type],
  );

  const { data, loading, error } = useRequest(
    () => fetchAdPlacements(requestParams),
    {
      refreshDeps: [requestParams],
      cacheKey: `dbs-ad-placement-${baseUrl}-${type || 'all'}`,
      ready: Boolean(baseUrl),
      onError: (err) => {
        console.error('[AlertTip] useAdPlacement error:', err);
      },
    },
  );

  const list = data || [];
  const marquees = useMemo(
    () => list.filter((item: IAdPlacementItem) => item?.type === 'marquee'),
    [list],
  );
  const newicons = useMemo(
    () => list.filter((item: IAdPlacementItem) => item?.type === 'newicon'),
    [list],
  );

  return {
    data: list,
    marquees,
    newicons,
    loading,
    error,
  };
};
